export default "__VITE_ASSET__C4xMIs0X__"